<template>
  <div class="footer-container">
    <div class="footer-box">
      <div class="logo-info flex-y-center">
        <img src="@/assets/img/logo.png" class="logo" alt="" />
        <span class="name">Q7</span>
      </div>
      <div class="flex">
        <ul v-for="(item, index) in linksList" :key="index" class="ul-box">
          <li class="li-title">{{ item.name }}</li>
          <li class="li-item" v-for="(child, i) in item.children" :key="i">
            <!-- <router-link :to="child.url" class="li-item"><span> {{ child.name }}</span></router-link> -->
            <div class="li-item" @click="goUrls(child.url)">{{ child.name }}</div>
          </li>
        </ul>
      </div>
      <div class="qrcode-wrapper flex-column-xy-center">
        <img :src="`https://q7w.com.cn/zty_server/QRCode/${idaqdk}`" />
        <span>小程序二维码</span>
      </div>
    </div>
    <div class="copyright ">
      <div>公司：中塔建湖北科技管理有限公司   客服：4001891168</div>
      <div>© 2022 平台公司名称 | 鄂ICP备2024068295号</div>
    </div>
  </div>
</template>

<script>
import { getQRImg } from '@/api/user.js';

export default {
  name: "PageFooter.vue",

  data() {
    return {
      idaqdk: '',//存二维码
      linksList: [
        {
          name: "规则介绍",
          url: "",
          children: [
            { name: "平台规则", url: "/helpCenter" },
            { name: "担保规则", url: "/helpCenter" },
            { name: "会员规则", url: "/helpCenter" },
          ],
        },
        {
          name: "操作指南",
          url: "",
          children: [
            { name: "用户指南", url: "/helpCenter" },
            { name: "店铺指南", url: "/helpCenter" },
            { name: "商家指南", url: "/helpCenter" },
          ],
        },
        {
          name: "关于我们",
          url: "",
          children: [
            { name: "平台介绍", url: "/helpCenter" },
            { name: "支付保障", url: "/helpCenter" },
          ],
        },
      ],
    };
  },
  created() {
    this.getQRImg()
  },
  methods: {
    goLogin() {//游客模式提示弹窗
      this.$confirm('您还未登录，请登陆后浏览', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '去登陆',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$router.push('/login')
        })
    },

    goUrls(url) {
      // if (!localStorage.getItem('token')) return this.goLogin()
      this.$router.push(url)
    },
    // method
    getQRImg() {
      getQRImg({}).then(res => {
        this.idaqdk = res.result

      }).catch(err => {
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.footer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #1e1e1e;
  padding-top: 1px;

  .footer-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    height: 350px;

    .logo-info {
      .logo {
        width: 100px;
        height: 100px;
        // border-radius: 50%;
        margin-right: 20px;
      }

      .name {
        font-weight: 800;
        font-size: 25px;
        color: #ffffff;
      }
    }
  }

  .ul-box {
    padding-right: 100px;

    .li-title {
      font-weight: 400;
      font-size: 18px;
      color: #c4c4c4;
      margin-bottom: 30px;
    }

    .li-item {
      margin-bottom: 30px;
      font-size: 16px;
      color: #8d8d8d;
      cursor: pointer;
    }

    .li-item:hover {
      text-decoration: underline;
    }
  }

  .ul-box:last-child {
    border-right: 1px solid #383838;
  }

  .qrcode-wrapper {
    img {
      width: 2.125rem;
      height: 2.125rem;
      margin-bottom: 20px;
    }

    span {
      font-weight: 400;
      font-size: 0.2rem;
      color: #ffffff;
    }
  }

  .copyright {
    width: 1200px;
    font-weight: 400;
    font-size: 16px;
    color: #c8c8c8;
    padding: 0.4125rem 0;
    border-top: 1px solid #383838;
    text-align: center;

    >div {
      padding: 4px 0;
    }
  }
}

ul,
li {
  list-style: none;
}
</style>
